import { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { Fab } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import L from "leaflet";
import { useParams } from "react-router-dom";

interface Coordinates {
  lat: number;
  lng: number;
}

const MapUpdater = ({ setPosition }: { setPosition: (position: Coordinates) => void }) => {
  const map = useMap();

  useEffect(() => {
    // Update position whenever the map center changes
    const onMoveEnd = () => {
      const center = map.getCenter();
      setPosition({ lat: center.lat, lng: center.lng });
    };

    map.on("moveend", onMoveEnd);

    // Cleanup on component unmount
    return () => {
      map.off("moveend", onMoveEnd);
    };
  }, [map, setPosition]);

  return null;
};

const FullScreenContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <div style={{ width: "100vw", height: "100vh", position: "relative" }}>{children}</div>;
};

export default function FullScreenMap() {
  const { lat, lng } = useParams();
  const latitude = lat ? parseFloat(lat) : 0.0;
  const longitude = lng ? parseFloat(lng) : 0.0;
  const [position, setPosition] = useState<Coordinates>({ lat: latitude, lng: longitude });

  const markerIcon = new L.Icon({
    iconUrl: "/map_assets/Marker.svg",
    iconSize: [80, 80],
    iconAnchor: [40, 80],
    popupAnchor: [1, -34],
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
    shadowSize: [52, 52],
  });

  const handleConfirmLocation = () => {
    console.log("Location confirmed:", position);
  };

  return (
    <FullScreenContainer>
      <MapContainer center={position} zoom={15} style={{ width: "100%", height: "100%" }}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Marker position={position} icon={markerIcon} />
        <MapUpdater setPosition={setPosition} /> {/* Updates the position on map move */}
      </MapContainer>
      <Fab
        onClick={handleConfirmLocation}
        color="primary"
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          zIndex: 1000,
        }}
      >
        <CheckIcon />
      </Fab>
    </FullScreenContainer>
  );
}
